export default function SLABadge({ daysElapsed, targetDays, status }) {
  if (targetDays == null) return null;

  const colors = {
    green: { bg: 'var(--color-success-bg)', text: 'var(--color-success)', border: '#86efac' },
    amber: { bg: 'var(--color-warning-bg)', text: 'var(--color-warning)', border: '#fcd34d' },
    red:   { bg: 'var(--color-error-bg)',   text: 'var(--color-error)',   border: '#fca5a5' },
  };
  const c = colors[status] || colors.green;

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      padding: '2px 8px',
      borderRadius: 20,
      fontSize: 11,
      fontWeight: 600,
      background: c.bg,
      color: c.text,
      border: `1px solid ${c.border}`,
      whiteSpace: 'nowrap',
    }}>
      {daysElapsed}d / {targetDays}d
    </span>
  );
}
